import axios from 'axios';
import ServerProperties from '../../config/server.js'
/*import {RequestinProcess,AddPaginationURL} from '../../helper/request.action.js'*/
// import Message from '../../config/message.js'
// import AuthenticationPresenter from '../../user/presenter.js'
export default {
  Register: function(params){
    // console.log(params)
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.AuthorizationToken;
    axios.defaults.headers.common['Content-Type'] = 'multipart/form-data'
    axios.post(
      ServerProperties.ATM_CLOUD.API+'Asset/Document/Register/',
      // {
      //   Asset:params.data.Asset,
      //   File:params.data.File,
      //   Filename:params.data.Filename
      //   // TakenTimeStamp : params.data.TakenTimeStamp,
      // },
      params.data,{
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
    )
    .then(function (response) {
      params.onsuccess(params, response);
      // console.log(response);
      // params.RunRedux(RequestinProcess({in_process:false,type:null}))
    })
    .catch(function (error) {
      params.onfailed(params, error);
      // params.RunRedux(RequestinProcess({in_process:false,type:null}))
      // params.onfailed(error.response.data)
    });
  },
  Read: function(params){
    // console.log(params)
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    // axios.defaults.headers.common['Content-Type'] = 'multipart/form-data'
    axios.get(
      ServerProperties.ATM_CLOUD.API+'Asset/Documents/'+params.data.AssetAlias,
    )
    .then(function (response) {
      params.onsuccess(params, response);
      // console.log(response);
      // params.RunRedux(RequestinProcess({in_process:false,type:null}))
    })
    .catch(function (error) {
      params.onfailed(params, error);
      // params.RunRedux(RequestinProcess({in_process:false,type:null}))
      // params.onfailed(error.response.data)
    });
  },
  Delete: function(params){
    // console.log(params)
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    // axios.defaults.headers.common['Content-Type'] = 'multipart/form-data'
    axios.put(
      ServerProperties.ATM_CLOUD.API+'Asset/Document/Delete/'+params.data.Alias+'/',
    )
    .then(function (response) {
      params.onsuccess(params, response);
      // console.log(response);
      // params.RunRedux(RequestinProcess({in_process:false,type:null}))
    })
    .catch(function (error) {
      params.onfailed(params, error);
      // params.RunRedux(RequestinProcess({in_process:false,type:null}))
      // params.onfailed(error.response.data)
    });
  },
  Open: function(params){
    // console.log(params)
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.defaults.headers.get['Content-Type'] = 'application/json'
    axios.get(
      ServerProperties.ATM_CLOUD.API+'Asset/Document/Open/'+params.data.Alias+'/?download=true',
      {
        // Asset:params.data.Asset,
        // File:params.data.File,
        // Filename:params.data.Filename
        // TakenTimeStamp : params.data.TakenTimeStamp,
        responseType: 'arraybuffer'
      },
      // params.data,
      {
        headers: {
          'content-type': 'application/json'
        }
      }
    )
    .then(function (response) {
      params.onsuccess(params, response)
    })
    .catch(function (error) {
      params.onfailed(params, error);
    });
  },
}



// WEBPACK FOOTER //
// ./src/App/asset/document/model.js